<template>
  <div class="part">
    
    <p class="label input-filter-label">
      {{ $lang.messages.uploadAttachment }}
    </p>
    
    <div
      class="attachment"
      v-for="(attachment, i) in eventAttachments"
      :key="i"
    >
      
      <span class="document">
        <f-p-documents :type="attachment.extension.toLowerCase()"></f-p-documents>
        <p :title="attachment.fileName + '.' + attachment.extension">{{ attachment.fileName }}.{{ attachment.extension }}</p>
      </span>
      
      <span class="download delete-ico" @click="deleteAttachment(attachment.attachmentGuid)">
        <img src="@/assets/images/payments/delete_ico.png" />
      </span>
      
    </div>
    
  </div>
</template>

<script>
  import FPDocuments from '../FPDocuments';
  
  export default {
    name: "FPInputUpload",
    components: {
      'f-p-documents': FPDocuments
    },
    props: {
      actionType: {
        type: String,
        required: true
      },
      eventAttachments: {
        type: [Array, Object],
        required: true
      }
    },
    methods: {
      deleteAttachment (val) {
        this.$emit('deleteAttachment', val)
      }
    }
  }
</script>
